/**
 * A2UI Text Component
 * Renders text with optional styling based on usageHint
 */

import React from 'react';

const usageHintStyles = {
  'h1': { fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' },
  'h2': { fontSize: '1.75rem', fontWeight: 'bold', marginBottom: '0.5rem' },
  'h3': { fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.5rem' },
  'h4': { fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem' },
  'h5': { fontSize: '1rem', fontWeight: 'bold', marginBottom: '0.5rem' },
  'h6': { fontSize: '0.875rem', fontWeight: 'bold', marginBottom: '0.5rem' },
  'body': { fontSize: '1rem' },
  'caption': { fontSize: '0.875rem', color: 'var(--text-secondary, #6c757d)' },
  'label': { fontSize: '0.875rem', fontWeight: '500' },
  'error': { fontSize: '0.875rem', color: 'var(--danger, #dc3545)' },
  'success': { fontSize: '0.875rem', color: 'var(--success, #198754)' },
};

const A2UIText = ({ 
  text,
  usageHint = 'body',
  style,
  resolveValue,
  surfaceId 
}) => {
  const resolvedText = resolveValue ? resolveValue(text, surfaceId) : text?.literalString || text || '';
  const hintStyle = usageHintStyles[usageHint] || usageHintStyles['body'];
  
  // Determine the appropriate HTML element based on usageHint
  const getElement = () => {
    switch (usageHint) {
      case 'h1': return 'h1';
      case 'h2': return 'h2';
      case 'h3': return 'h3';
      case 'h4': return 'h4';
      case 'h5': return 'h5';
      case 'h6': return 'h6';
      case 'label': return 'label';
      default: return 'span';
    }
  };
  
  const Element = getElement();
  
  return (
    <Element 
      className="a2ui-text"
      style={{ ...hintStyle, ...style }}
    >
      {resolvedText}
    </Element>
  );
};

export default A2UIText;
